import { ID } from 'api'
import { storage } from 'utils/localStorage'
import { create } from 'zustand'

interface Store {
  publisherId: string
  setPublisherId: (id: ID) => void
}

export const usePublisherStore = create<Store>((set) => ({
  publisherId: (() => {
    return storage.getValue('publisherId') ?? ''
  })(),
  setPublisherId: (publisherId) => {
    set(() => ({ publisherId }))

    storage.setValue('publisherId', publisherId)
  },
}))
